import script from "./EmployeeAdditionalBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeAdditionalBenefits.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeAdditionalBenefits.vue?vue&type=style&index=0&id=6dc7d04c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc7d04c"]])

export default __exports__